import { FC } from 'react';
import { JsonLD } from './json-ld';
import { SharingCardMeta } from '@user/head/sharing-card';

export const UserFollowHead: FC = () => {
  return (
    <>
      <SharingCardMeta />
      <JsonLD />
    </>
  );
};
